import { Stack } from "@mui/material";
import React from "react";
import CategoryPreview from "../Preview/CategoryPreview";
import ProductDetailPreview from "../../AddProductVariant/Preview/ProductDetailPreview";
import OndcDataPreview from "../../AddProductVariant/Preview/OndcDataPreview";
import VaraintProductPreview from "../../AddProductVariant/Preview/VaraintProductPreview";
import VariantOndcPreview from "../../AddProductVariant/Preview/VariantOndcPreview";

function ProductPreviewTab({
  variantData,
  tableHeader1,
  tableHeader2,
  productInfo,
  ondcDetails,
}) {
  return (
    <Stack>
      <ProductDetailPreview productInfo={productInfo} />
      <OndcDataPreview
        ondcEnabled={ondcDetails?.ondcEnabled?.toLowerCase() == "yes"}
        timeToShip={ondcDetails?.timeToShip}
        timeUnit={ondcDetails?.timeUnit}
        cod={ondcDetails?.cod}
        fragile={ondcDetails?.fragile}
        returnable={ondcDetails?.returnable}
        returnPeriod={ondcDetails?.returnPeriod}
        sellerPickup={ondcDetails?.sellerPickup}
        cancellable={ondcDetails?.cancellable}
        refundEligible={ondcDetails?.refundEligible}
        cancellationFee={ondcDetails?.cancellationFee}
        dynamicSpecs={ondcDetails?.dynamicSpecs}
        productCode={ondcDetails?.productCode}
        productCodeValue={ondcDetails?.productCodeValue}
        unitOfMeasure={ondcDetails?.unitOfMeasure}
        unitOfMeasureValue={ondcDetails?.unitOfMeasureValue}
      />
      <VaraintProductPreview
        variantData={variantData}
        header={[...tableHeader1?.slice(1), { title: "Main", id: "500" }]}
      />
      <VariantOndcPreview variantData={variantData} header={tableHeader2} />
    </Stack>
  );
}

export default ProductPreviewTab;
